
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor("Matrix.Workflow.ApprovalStatus")
    export class ApprovalStatusEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container);

            this.addOption('PENDING', 'PENDING');
            this.addOption('APPROVED', 'APPROVED');
            this.addOption('REJECTED', 'REJECTED');
        }


    }
}